import { render } from "./Wage.vue?vue&type=template&id=502cfd18"
import script from "./Wage.vue?vue&type=script&lang=ts"
export * from "./Wage.vue?vue&type=script&lang=ts"

import "./Wage.vue?vue&type=style&index=0&id=502cfd18&lang=less"
script.render = render

export default script